"use strict";

exports.__esModule = true;
exports.MachineStateCountWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _widgetGroups = require("../widgetGroups");
var _MachineStateCountElement = require("./MachineStateCountElement");
var _MachineStateCountFields = require("./MachineStateCountFields");
var _MachineStateCountHeader = require("./MachineStateCountHeader");
var _MachineStateCountThumbnail = require("./MachineStateCountThumbnail");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MachineStateCountWidget = exports.MachineStateCountWidget = {
  name: "MachineStateCount",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MachineStateCountWidget.label",
    defaultMessage: "Machine State Count"
  }),
  icon: "numbered-list",
  group: _widgetGroups.DEVICE_INFORMATION_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "MachineStateCount",
      props: Object.assign({
        width: 256,
        height: 64,
        hideLabel: false,
        showOtherDevices: false,
        showTotalDevices: false,
        totalSeparator: " of ",
        labelSize: 0.2
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource", "hideLabel", "labelSize", "stateId", "showTotalDevices", "showOtherDevices", "totalSeparator"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Header: _MachineStateCountHeader.ConnectedMachineStateCountHeader,
    Element: _MachineStateCountElement.ConnectedMachineStateCountElement,
    Fields: _MachineStateCountFields.MachineStateCountFields,
    Thumbnail: _MachineStateCountThumbnail.MachineStateCountThumbnail
  }
};